import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default theme => ({
  root: {
    maxHeight: 400,
    margin: 16,
    boxSizing: 'border-box',
    borderRadius: 6,
    boxShadow: '0 1px 6px 0 rgba(32, 33, 36, 0.38)'
  },
  header: {
    width: '100%',
    height: 40,
    boxSizing: 'border-box',
    padding: '0 16px 0 16px',
    borderBottom: `1px solid ${theme.colors.grey[100]}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  body: _objectSpread({
    width: '100%',
    maxHeight: 'calc(400px - 40px)',
    boxSizing: 'border-box',
    padding: 16,
    overflow: 'auto',
    display: 'flex'
  }, theme.utils.scrollbar),
  bodyChart: {
    justifyContent: 'center'
  },
  bodyTable: {},
  actions: {},
  action: {
    width: 14,
    height: 14,
    cursor: 'pointer',
    '& svg': {
      width: 14,
      height: 14,
      '& path': {
        fill: theme.colors.actionMinor[500]
      },
      '&:hover': {
        '& path': {
          fill: theme.colors.actionMinor[600]
        }
      }
    }
  }
});